<template>
	<div class="vx-card col-span-3">

		<div class="grid grid-flow-row grid-cols-5 p-6">
			<h2 class="text-4xl col-span-2 truncate">Trend Analysis</h2>

			<div class="">
				<!-- period select -->
				<div class="relative inline-block w-full text-gray-700">
					<select v-model="periodFilter" class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:shadow-outline" 
						style="border: 1px solid rgba(60, 60, 60, 0.26)">
						<option
							v-for="(item, idx) in periodFilterOptions"
							:key="idx"
							:value="item.id"
						>
							{{ item.label }}
						</option>
					</select>
					<div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
						<svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
					</div>
				</div>
			</div>

			<div class="col-span-2 flex">
				<div class="self-center pl-6 whitespace-nowrap">
					Tops &amp; Flops for
				</div>

				<div class="flex-grow pl-4">
					<div class="relative inline-block w-full text-gray-700">

						<select v-model="categoryFilter"class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:shadow-outline" 
							style="border: 1px solid rgba(60, 60, 60, 0.26)">
							<option value="overall">Overall</option>
							<option
								v-for="(item, idx) in categories"
								:key="idx"
								:value="item.field"
							>
								{{ item.label }}
							</option>
						</select>
						<div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
							<svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
						</div>
					</div>
				</div>
			</div>

		</div>


		<div class="grid grid-flow-row grid-cols-5 px-6 pb-6">
			<!-- Trends -->
			<div
				class="col-span-3 pr-6 flex flex-col"
				style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
			>

				<div>
					<ship-review-trend-analysis-item
						key="overall_score"
						field="overall_score"
						label="Overall"
						:ship="ship"
						:period="period"
						:comparison="comparisonPeriod"
						:labelXxl="true"
						:showLegend="true"
					/>
				</div>

				<div>
					<ship-review-trend-analysis-item
						v-for="cat in categories"
						:key="cat.field"
						:field="cat.field + '_score'"
						:label="cat.label"
						:ship="ship"
						:period="period"
						:comparison="comparisonPeriod"
					/>
				</div>


			</div>

			<!-- Tops and Flops -->
			<div class="col-span-2 pl-6">

				<!-- Tops -->
				<div v-if="ship" class="mb-6">
					<h3 class="text-2xl mb-6">Tops</h3>
					<ship-review-trend-analysis-top-item
						v-for="idx in [1, 2, 3, 4, 5]"
						:key="'top_' + idx"
						:field="'top_' + idx"
						:ship="ship"
						:deltaPeriod="periodFilter"
						:category="categoryFilter"
					/>

					<h3 class="text-2xl mb-6 mt-6 pt-3 " style="NOTborder-top: 1px solid rgba(0, 0, 0, 0.1);">Flops</h3>
					<ship-review-trend-analysis-top-item
						v-for="idx in [1, 2, 3, 4, 5]"
						:key="'flop_' + idx"
						:field="'flop_' + idx"
						:ship="ship"
						:deltaPeriod="periodFilter"
						:category="categoryFilter"
					/>
				</div>

				<div class="flex place-items-center mt-2 text-xs mt-4">
					<div style="background: #a8a8a8; height: .75rem; width: .125rem" class="mr-2"></div>
					= benchmark to cruiseline average
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ShipReviewTrendAnalysisItem from "@/components/cat/ShipReviewTrendAnalysisItem.vue";
import ShipReviewTrendAnalysisTopItem from "@/components/cat/ShipReviewTrendAnalysisTopItem.vue";

export default {
	props: {
		ship: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			period: "new",
			comparisonPeriod: "mid",
			periodFilter: "new_mid",
			categoryFilter: "overall",
			periodFilterOptions: [
				{
					id: "new_mid",
					label: "new to mid",
				},
				{
					id: "mid_old",
					label: "mid to old",
				},
				{
					id: "new_old",
					label: "new to old",
				},
			],
			categories: [
				{ field: "service", label: "Service" },
				{ field: "food_beverage", label: "Food & Beverage" },
				{ field: "cabin", label: "Cabins" },
				{ field: "onboard_facilities", label: "Onboard Facilities" },
				{ field: "entertainment", label: "Entertainment" },
				{ field: "onboard_activities", label: "Onboard Activities" },
				{ field: "wifi", label: "WIFI" },
			],
		};
	},
	components: {
		ShipReviewTrendAnalysisItem,
		ShipReviewTrendAnalysisTopItem,
	},
	watch: {
		periodFilter(val) {
			/// console.log("PF:", val, val.split("_"));
			let f = val.split("_");
			this.period = f[0];
			this.comparisonPeriod = f[1];
		},
	},
};
</script>